module.exports = __webpack_public_path__ + "assets/img/kv-5a0189df.jpg";